import(/* webpackMode: "eager" */ "/home/ubuntu/download/69883ec5921dc900142f22f1/website_project/src/app/news/page.tsx");
